import { Panel, PanelBody, PanelGrid, PanelGridAmount, PanelGridItem } from 'components';
import { RepayInfoData } from 'types';
import styles from './RepayInfo.module.scss';
import { formatDate } from 'functions';

type Props = {
    repayInfo: RepayInfoData
}

export default function RepayInfo({ repayInfo }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Date: "}
                            value={<span>{repayInfo.invoiceDate ? formatDate(new Date(repayInfo.invoiceDate)) : 'Not Found'}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridAmount
                            label={"Amount: "}
                            value={repayInfo.repayAmount}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Mock Invoice Number: "}
                            value={repayInfo.mockInvoiceNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Repay Number: "}
                            value={repayInfo.repayNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Reference Number: "}
                            value={repayInfo.referenceNumber}
                        />
                    </div>

                </PanelGrid>

            </PanelBody>
        </Panel>
    )
}